import Modal from "react-modal";
import React from "react";
import wrongAnswer from "../../images/wrongAnswer.png";

export const WrongModal = ({
  show,
  onClose,
  onContinue,
  correctAnswer,
  referenceAnswer,
}) => {
  // const [showReference, setShowReference] = useState(false);

  // const handleToggle = () => {
  //   setShowReference(!showReference);
  // };

  return (
    <>
      <Modal className="DoneModalBox" isOpen={show} onRequestClose={onClose}>
        <div className="">
          <div className="DoneContent">
            <div className=" modalContainer1">
              <div className="d-flex justify-content-center align-items-center gap-2">
                <img className="rightImage" src={wrongAnswer} alt="" />
                <p className="paragraphWrongTitle mt-2 ">
                  <span className="text-danger">Sorry, doctor!</span>{" "}
                </p>
              </div>
              <div>
                <p className="paragraphWrong ">
                  <span className="text-danger">
                    The correct answer is:{" "}
                    <span className="text-black">{correctAnswer}</span>
                  </span>
                </p>

                {/* <div className="">
                  <button
                    className="text-white bg-purpleColor rounded px-2 py-1 mb-2"
                    onClick={handleToggle}
                  >
                    {showReference
                      ? "Hide Information"
                      : "Click for more information"}
                  </button>
                </div> */}

                <p
                  className="paragraphRef"
                  dangerouslySetInnerHTML={{ __html: referenceAnswer }}
                ></p>

                <p className="paragraphWrong">
                  You can still try another Question!
                </p>
                <span className="numberzero">0</span>
              </div>

              <div className="contButt">
                <button onClick={onContinue} className=" ContinueButton1">
                  Continue
                </button>
              </div>
            </div>
          </div>
        </div>
      </Modal>
    </>
  );
};
